import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=c9c44dc2&scoped=true"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=c9c44dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c44dc2",
  null
  
)

export default component.exports